import type { SignoffsField } from './signoffTypes'

/**
 * Every slot's `active` flag cleared, leaving each `signatures` history intact
 * and each slot open to be signed again.
 */
export function deactivateSignoffs(signoffs: SignoffsField): SignoffsField {
  return Object.fromEntries(
    Object.entries(signoffs).map(([slotId, state]) => [
      slotId,
      { ...state, active: false },
    ])
  )
}
